import React, { memo } from 'react';
import { Link } from 'react-router-dom';
import { distillProductType, toggleDisplayNameForDevices } from 'common/utils/helpers';
import { IconLoader } from 'common/IconLoader';
import styles from './DevicePill.module.css';

function DevicePill({ duId, device, deviceDisplayMode }) {
  const deviceId = device.deviceId ?? device.id ?? '';
  const deviceName = toggleDisplayNameForDevices(device, deviceDisplayMode);
  const productType = distillProductType(device.properties?.reported?.productType);

  return (
    <div className={styles.root}>
      <img alt="" src={productType === 'service' ? IconLoader.icon_service : IconLoader.icon_donor} />
      <div className={styles.text} data-tip={deviceName}>
        <Link to={`/console/devices/pivot/overview?deviceId=${duId}&detail=${deviceId}`}>{deviceName}</Link>
      </div>
    </div>
  );
}

export default memo(DevicePill);
